export function useFullActualLoaded() {
  const MS = useMarketsStore()

  return {
    isFullActualLoaded: computed(() => MS.systemStates.fullActualLoaded),
  }
}
